var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-surveys"},[(_vm.loading)?_c('Loader'):(_vm.lastSurvey)?_c('holder-survey',{key:_vm.lastSurvey.id,attrs:{"survey":_vm.lastSurvey}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }